<template>
    <div
        :class="parentClass"
        @click="optionClick"
    >
        <span :class="selectedClass('DropdownOption__label')">
            <RPCheckbox
                v-if="showCheckbox"
                :value="selected"
            />
            <span class="DropdownOption__label-text">{{ label }}</span>
        </span>
        <div class="DropdownOption__description-container">
            <StreamlineIcon
                v-if="showIcon"
                class="DropdownOption__icon"
                :icon="icon"
                :size="16"
                :stroke="iconColor"
            />
            <span :class="selectedClass('DropdownOption__description')">{{ description }}</span>
        </div>
    </div>
</template>
<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import RPCheckbox from '../RPCheckbox.vue';
import isEmpty from 'lodash/isEmpty';
import colors from 'style/_colors.scss';
import statusBuilder from 'status/statusBuilder';
import status from 'status';

export default {
    name: 'DropdownOption',
    components: {
        RPCheckbox,
        StreamlineIcon
    },
    props: {
        value: {
            type: [String, Number, Boolean],
            default: null
        },
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: [Object, Array],
            default: () => ({}),
        },
        iconPosition: {
            type: String,
            default: 'right'
        },
        color: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: '',
        },
        showCheckbox: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false,
        },
        noBorder: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        showIcon(){
            return !isEmpty(this.icon);
        },
        iconColor(){
            if(this.color !== ''){
                return this.color;
            }
            return this.selected
                ? colors.primary
                : colors.textDark;
        },
        parentClass() {
            let value = this.selectedClass('DropdownOption');
            if (this.iconPosition === 'left') {
                value = value + ' DropdownOption--reversed';
            }
            return value;
        }
    },
    methods: {
        selectedClass(base){
            return statusBuilder(
                base,
                status.STANDBY,
                false,
                {
                    selected: this.selected,
                    'no-border': this.noBorder
                }
            );
        },
        optionClick(){
            if(this.selected ){
                this.$emit('deselect', this.value);
            } else {
                this.$emit('select', this.value);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
    .DropdownOption {
        cursor: pointer;
        font-family: proxima-nova, sans-serif;
        min-height: 2rem;
        padding: .25rem .5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0;
        border-radius: 0;
        border-bottom: 1px solid $grey-100;
        white-space: nowrap;

        &--reversed {
            flex-direction: row-reverse;
        }

        &:hover{ background: $grey-50; }
        &--no-border {
            border-bottom: none
        }
        &--selected {
            background: $primary-50;
            &:hover{ background: $primary-50; }
        }
        &__label {
            margin: auto 0;
            display: flex;
            &--selected { color: $primary-300; }
        }
        &__label-text:not(:first-child){
            margin-left: 0.5rem
        }
        &__description-container{
            position: relative;
            display: flex;
            align-items: center;
        }
        &__icon {
            margin: auto 0.25rem auto 0;
        }
        &__description {
            margin: auto 0;
            &--selected { color: $primary-300; }
        }
    }
</style>
